import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { components } from 'react-select';
import { KTag } from '@/ui-library/components';

export const SelectWithDescriptionMultiValueLabel = (props) => {
  const { data, selectProps = {} } = props;
  const { extraProps = {} } = selectProps;
  const { labelKey = 'label', remoteKey = 'remote' } = extraProps;

  const label = data?.[labelKey];
  const isRemote = data?.[remoteKey];

  return (
    <components.MultiValueLabel {...props}>
      <Flex gap="6px" alignItems="center">
        <KText size="sm-regular" color="secondary-900">
          {label}
        </KText>
        {isRemote && (
          <KTag
            bg="secondary-25"
            color="secondary-700"
            size="xs-regular"
            value="Remote"
          ></KTag>
        )}
      </Flex>
    </components.MultiValueLabel>
  );
};
